import { createReducer, on } from '@ngrx/store';
import { MultiAssessmentState } from './multi-assessment.state';
import * as MultiAssessmentActions from './multi-assessment.actions';

import { normalizeConfig } from 'src/app/shared/utils/assessment-navigator';

export const initialMultiAssessmentState: MultiAssessmentState = {
  selectedAssessment: null,
  student: null,
};

export const multiAssessmentReducer = createReducer(
  initialMultiAssessmentState,

  on(MultiAssessmentActions.setMultiAssessment, (state, { assessment }) => ({
    ...state,
    selectedAssessment: assessment ? normalizeConfig(assessment) : null,
  })),

  on(
    MultiAssessmentActions.setMultiAssessmentStudent,
    (state, { student }) => ({
      ...state,
      student,
    })
  ),

  on(
    MultiAssessmentActions.resetMultiAssessment,
    () => initialMultiAssessmentState
  )
);
